import React from 'react';
import { ArrowRight, Download, Infinity, FileText } from 'lucide-react';
export function HeroSection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-77">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-[#d4a853]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-78" />

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-79">
        {/* Text Content */}
        <div className="text-center md:text-left space-y-6" data-id="element-80">
          <div className="inline-block px-4 py-1.5 rounded-full bg-[#d4a853]/10 border border-[#d4a853]/20" data-id="element-81">
            <span className="text-[#d4a853] font-semibold text-sm tracking-wide" data-id="element-82">
              Nadie te preparó para entender tu mundo emocional…
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-bold leading-tight text-white" data-id="element-83">
            Entendé tu apego. <br data-id="element-84" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a853] to-[#fce3b4]" data-id="element-85">
              Recuperá estabilidad.
            </span>{' '}
            <br data-id="element-86" />
            Elegí mejor.
          </h1>

          <p className="text-lg text-gray-300 leading-relaxed max-w-xl mx-auto md:mx-0" data-id="element-87">
            Comprendé por qué te enganchás de más, te cuesta soltar y repetís
            patrones. Este libro te da las herramientas para cambiar tu realidad
            afectiva.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center md:justify-start" data-id="element-88">
            <button onClick={scrollToCheckout} className="px-8 py-4 bg-[#d4a853] hover:bg-[#b88e3e] text-black font-bold text-lg rounded-xl transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,168,83,0.3)] flex items-center justify-center gap-2" data-id="element-89">
              Quiero empezar hoy
              <ArrowRight className="w-5 h-5" data-id="element-90" />
            </button>

            <button onClick={scrollToCheckout} className="px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium text-lg rounded-xl transition-all flex items-center justify-center" data-id="element-91">
              Ver combos y precios
            </button>
          </div>

          <div className="flex flex-wrap justify-center md:justify-start gap-4 pt-4 text-xs sm:text-sm text-gray-400" data-id="element-92">
            <div className="flex items-center gap-1.5" data-id="element-93">
              <Download className="w-4 h-4 text-[#d4a853]" data-id="element-94" />
              <span data-id="element-95">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-96">
              <Infinity className="w-4 h-4 text-[#d4a853]" data-id="element-97" />
              <span data-id="element-98">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-99">
              <FileText className="w-4 h-4 text-[#d4a853]" data-id="element-100" />
              <span data-id="element-101">PDF premium</span>
            </div>
          </div>
        </div>

        {/* Image Content */}
        <div className="relative flex justify-center md:justify-end" data-id="element-102">
          <div className="relative w-[280px] sm:w-[350px] md:w-[400px] aspect-[2/3] transform rotate-3 hover:rotate-0 transition-all duration-700" data-id="element-103">
            <div className="absolute inset-0 bg-[#d4a853] blur-2xl opacity-20 animate-pulse" data-id="element-104"></div>
            <img src="https://cdn.magicpatterns.com/uploads/1sUAJC4SxGmBDYRPVxvw9N/ChatGPT_Image_4_feb_2026,_14_36_30.png" alt="Psicología del Apego Moderno Libro" className="relative w-full h-full object-contain drop-shadow-2xl z-10" data-id="element-105" />
          </div>
        </div>
      </div>
    </section>;
}